export const getImageNatureSize = async (imgDom) => {
    if (imgDom.naturalWidth) {
        return {
            width: imgDom.naturalWidth,
            height: imgDom.naturalHeight
        };
    } else {
        let rect = await getImageSizeByUrl(imgDom.src);
        return rect;
    }
};

export const getImageSizeByUrl = async (url) => {
    return new Promise((resolve, reject) => {
        let img = new Image();
        img.onload = () => {
            resolve({
                width: img.width,
                height: img.height
            });
        };
        img.onerror = () => {
            reject(new Error('图片异常'));
        };
        img.src = url;
    });
};

// 检查图片地址是否可被加载
export const checkImageLoadable = async (url) => {
    return new Promise((resolve, reject) => {
        let img = new Image();
        img.onload = () => {
            resolve(true);
        };
        img.onerror = () => {
            resolve(false);
        };
        img.src = url;
    });
};

// 检查本地图片是否可被加载
export const checkLocalImageLoadable = async (file) => {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            resolve(true);
        };
        reader.onerror = () => {
            resolve(false);
        };
    });
};

// 检查本地图片是否可展示
export const checkLocalImageShowable = async (file) => {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            let img = new Image();
            img.onload = () => {
                resolve(true);
            };
            img.onerror = () => {
                resolve(false);
            };
            img.src = reader.result;
        };
        reader.onerror = () => {
            resolve(false);
        };
    });
};

export const changeImgUrl = (url) => {
    // 截取URL，去掉前面的域名
    if (url.indexOf('/llm/') >= 0) {
        url = '/llm-files/' + url.substring(url.indexOf('/llm/') + 5);
    }
    return url;
};
